(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Provincia', Provincia);

    Provincia.$inject = ['$resource'];

    function Provincia ($resource) {
        var resourceUrl =  'api/provincias/:id?size=2000';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
